var id = 0;

export default function (html, data) {
    var image = '/img/V2/page/mass-media/bg-' + id + '.svg?=2';
    id = id ? 0 : 1;
    html.css({
        'background-image': 'linear-gradient(0deg, rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6)), url(' + image + ')',
        'background-position': 'right'
    });

    return html;
}